import React, { Component } from "react";

import { CButton } from "@coreui/react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import { InputGroup, Input, FormGroup } from "reactstrap";

const grid = 8;

// Função auxiliar para reordenar a lista
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const getListStyle = () => ({
  padding: grid,
  width: "100%",
  display: "flex",
  justifyContent: "start",
  flexFlow: "wrap",
  border: "1px solid #d8dbe0",
  borderRadius: "0.25rem",
  backgroundColor: "white"
});

const dropeListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  justifyContent: "start",
  border: "2px dashed #d8dbe0",
  borderRadius: "0.25rem",
  minHeight: "160px",
  overflowX: "scroll"
});

class ClickAndDropActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [], // Lista de cima (disponíveis)
      selected: [] // Lista de baixo (selecionados)
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.setState({
      items: this.props.list.map(item => ({ ...item, content: item.name })),
      selected: this.props.list2
    });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.list !== this.props.list) {
      this.setState({
        items: nextProps.list.map(item => ({ ...item, content: item.name }))
      });
    }
    if (nextProps.list2 !== this.props.list2) {
      this.setState({
        selected: nextProps.list2
      });
    }
  }

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    this.setState(prevState => {
      const items = reorder(
        prevState.selected,
        result.source.index,
        result.destination.index
      );

      if (this.props.getOrder) {
        this.props.getOrder(items);
      }

      return { selected: items };
    });
  };

  handleItemClick = item => {
    this.props.selectedItem(item);
  };

  selectChange = item => {
    this.setState(prevState => {
      const updatedItems = prevState.items.map(currentItem => {
        if (item.id === currentItem.id) {
          return { ...currentItem, checked: !currentItem.checked };
        }
        return currentItem;
      });

      if (this.props.getChecked) {
        const updatedItem = updatedItems.find(
          currentItem => currentItem.id === item.id
        );
        this.props.getChecked(updatedItem);
      }

      return { items: updatedItems };
    });
  };

  render() {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <div>
          {/* LISTA DE CIMA (Disponíveis, Apenas Clickar) */}
          <div style={getListStyle()}>
            {this.state.items.map(item => (
              <div
                key={item.id}
                className={this.props.orderOnly ? "orderContent" : "typeBox"}
                onClick={() => this.handleItemClick(item)}
                style={{ cursor: "pointer" }}
              >
                <div className="warp-item-dnd">
                  {this.props.checkbox ? (
                    <div>
                      <FormGroup className="filterCheckBox dndCheckBox">
                        <InputGroup>
                          <Input
                            placeholder="select"
                            onChange={() => this.selectChange(item)}
                            checked={item.checked || false}
                            type="checkbox"
                          />
                        </InputGroup>
                      </FormGroup>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="w-100 h-100">
                    <div className="typeContent">
                      {!this.props.orderOnly ? (
                        item.icon ? (
                          <div className={`typeIcon bg-${item.color}`}>
                            <i className={`fa fa-${item.icon}`}></i>
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      <div className="typeTitle text-ellipsis">
                        {item.content}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* LISTA DE BAIXO (Selecionados, deve arrastar) */}
          {this.props.dropArea && (
            <div>
              <div className="mt-3 mb-2">{this.props.dropName}</div>

              <Droppable
                droppableId="droppable-selected"
                direction="horizontal"
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={dropeListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                  >
                    {this.state.selected.map((item, index) => (
                      <Draggable
                        key={`${item.type}-${item.list.id}-${index}`}
                        draggableId={`${item.type}-${item.list.id}-${index}`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              backgroundColor: "white"
                            }}
                          >
                            <div className="typeBox editable">
                              <div
                                className="typeEdit"
                                onClick={() =>
                                  this.props.editItem(
                                    item.type,
                                    item.list.id,
                                    this.props.list.find(
                                      type => type.id === item.type
                                    )
                                  )
                                }
                              >
                                <div
                                  className={`bg-helper bg-${
                                    item.type === 23
                                      ? "dark"
                                      : this.props.list.find(
                                          type => type.id === item.type
                                        )?.color || "warning"
                                  }`}
                                ></div>
                                <i className="fa fa-pencil text-white" />
                              </div>
                              <CButton
                                color="secondary"
                                className="typeCloseButton"
                                onClick={() =>
                                  this.props.removeItem(item.type, item.list.id)
                                }
                              >
                                <i className="fa fa-close"></i>
                              </CButton>
                              <div className="typeContent">
                                <div
                                  className={`typeIcon bg-${
                                    item.type === 23
                                      ? "dark"
                                      : this.props.list.find(
                                          type => type.id === item.type
                                        )?.color
                                  }`}
                                >
                                  <i
                                    className={`h-auto fa fa-${
                                      item.type === 23
                                        ? "video-camera"
                                        : this.props.list.find(
                                            type => type.id === item.type
                                          )?.icon
                                    }`}
                                  ></i>
                                </div>
                                <div className="typeTitle text-ellipsis">
                                  {item.list.name}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          )}
        </div>
      </DragDropContext>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(mapStateToProps)(ClickAndDropActivity);
